import React from 'react';
import Reveal from './Reveal';

/**
 * PublicSection — vertical rhythm + max-width wrapper for public pages.
 *
 * Variants: default (bg-background) · alt (bg-card) · muted (bg-muted)
 * Header (eyebrow + title + description) fades up on scroll.
 */
export default function PublicSection({
  id,
  eyebrow,
  title,
  description,
  children,
  variant = 'default',
  align = 'left',
  size = 'md',
  padTop,
  padBottom,
  className = '',
  testId,
}) {
  const variantClass =
    variant === 'alt' ? 'bg-card' : variant === 'muted' ? 'bg-muted' : 'bg-background';

  const defaultTop = size === 'lg' ? 'pt-24 md:pt-32' : 'pt-20 md:pt-28';
  const defaultBottom = size === 'lg' ? 'pb-24 md:pb-32' : 'pb-20 md:pb-28';
  const padYTop = padTop || defaultTop;
  const padYBottom = padBottom || defaultBottom;
  const alignClass = align === 'center' ? 'text-center items-center' : 'text-left';

  return (
    <section
      id={id}
      data-testid={testId}
      className={`relative w-full ${variantClass} ${padYTop} ${padYBottom} px-4 sm:px-6 scroll-mt-20 ${className}`}
    >
      <div className="max-w-6xl mx-auto">
        {(eyebrow || title || description) && (
          <Reveal
            className={`flex flex-col ${alignClass} max-w-3xl ${
              align === 'center' ? 'mx-auto' : ''
            } mb-14 md:mb-16`}
          >
            {eyebrow && (
              <div
                className={`flex items-center gap-3 mb-4 ${
                  align === 'center' ? 'justify-center' : ''
                }`}
              >
                <span aria-hidden className="h-4 w-1 bg-primary" />
                <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-primary">
                  {eyebrow}
                </p>
              </div>
            )}
            {title && (
              <h2 className="text-4xl sm:text-5xl font-heading font-black tracking-tight text-foreground leading-[1.05]">
                {title}
              </h2>
            )}
            {description && (
              <p className="mt-5 text-base md:text-lg text-muted-foreground leading-relaxed">
                {description}
              </p>
            )}
          </Reveal>
        )}
        {children}
      </div>
    </section>
  );
}
